/** @internal */
export const OP_LEFT = "Left";
/** @internal */
export const OP_RIGHT = "Right";
/** @internal */
export const OP_BOTH = "Both";
/** @internal */
export const OP_EITHER = "Either";
//# sourceMappingURL=streamHaltStrategy.js.map